import { UPDATE_GUTTAGEKONTO } from '@/domain/mitarbeiter/features/guttagekonto/hooks/graphql/mutations';
import { useCallback } from 'react';
import { useMutation } from '@apollo/client/react';
import { UpdateGuttagekontoMutation } from '@/gql/graphql';
import { ApolloClient } from '@apollo/client';

type UpdateGuttagekontoHook = {
  updateGuttagekonto: (
    idMitarbeiter: string,
    jahr: number,
    uebertragAusVorjahr: number,
  ) => Promise<ApolloClient.MutateResult<UpdateGuttagekontoMutation>>;
  error: Error | undefined;
};

export function useUpdateGuttagekonto(): UpdateGuttagekontoHook {
  const [execute, { error }] = useMutation(UPDATE_GUTTAGEKONTO, {
    refetchQueries: ['GetMitarbeiterGuttagekontoById'],
    fetchPolicy: 'no-cache',
  });

  const updateGuttagekonto = useCallback(
    (idMitarbeiter: string, jahr: number, uebertragAusVorjahr: number) =>
      execute({
        variables: { idMitarbeiter, jahr, uebertragAusVorjahr },
      }),
    [execute],
  );

  return {
    updateGuttagekonto,
    error,
  };
}
